<template lang="html">
  <div style="
        border-radius: 10px;
        position: absolute;
        margin-top: 0px;
        margin-right: 0px;
        margin-bottom: 0px;
        padding: 0px;
        border: 0px;
        background: white;
        overflow: hidden;
        z-index: 16000004;
        right: 30px;
        left: 30px;
        bottom: 120px;
        width: 450px;
        height: 530px;
        box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 3px 2px;
      " id="sticker" @mousedown="dragElement" ref="sticker">
    <v-card :style="stylechat">
      <v-app-bar flat class="titleBar" style="cursor: pointer" @mousedown="dragElement">
        <p class="HeaderName mb-4">
          {{ $t('ChatSide.sticker') }}
        </p>
        <v-spacer></v-spacer>
        <v-btn icon color="white" @click="closeDialog()" small class="mb-4">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-app-bar>
      <v-divider></v-divider>
      <v-card-text class="pt-0">
        <v-row style="height: 500px;" class="justify-center align-center" v-if="progress_loading">
          <v-progress-circular :size="80" color="#2463af" :width="6"
            :indeterminate="progress_loading"></v-progress-circular>
        </v-row>
        <div class="chat-container" :style="scrollable" v-else>
          <!-- {{ msgSend }} | new => {{ new_startPost }} -->
          <v-tabs v-model="tabs" centered slider-color="#2463af">
            <v-tab v-for="(i, index) in list_title" :key="`${i.key}-${index}-'title'`" :href="`#tab-${i.key}`">
              {{ i.text }}
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tabs">
            <v-tab-item v-for="(item, idx) in list_title" :key="`${idx}-${item.key}`" :value="`tab-${item.key}`">
              <v-card flat class="pa-0" >
                <v-card-text class="pt-0 pr-0 pl-0" v-if="item.key === '1'">
                  <v-item-group mandatory>
                    <v-container class="pl-0 pr-0">
                      <v-row class="justify-center align-center">
                        <v-col @click="selectTitleSticker(sticker)" v-for="sticker in list_sticker_title" :key="`${sticker}`" cols="2" align="center"
                          justify="center" class="pa-0 pt-3">
                          <v-item v-slot="{ active, toggle }">
                            <v-card :color="active ? '#9e9e9e9c' : 'white'" class="d-flex align-center" dark height="40"
                              width="40" @click="toggle">
                              <div class="flex-grow-1 text-center">
                                <img :src="sticker" width="30px" height="30px">
                              </div>
                            </v-card>
                          </v-item>
                        </v-col>
                      </v-row>

                      <div class="list-overflow" v-if="token_sticker !== ''">
                        <v-row  class="pa-0 pt-3 justify-start align-center">
                          <v-col cols="4" v-for="(item, index) in list_sticker_token[0].list_sticker" :key="index">
                            <img @click="emitSticker(item)" :src="item.s3_name" :alt="item.name" class="img-sticker">
                          </v-col>
                        </v-row>
                      </div>
                    </v-container>
                  </v-item-group>
                </v-card-text>
                <v-card-text class="pt-0 pr-0 pl-0" v-if="item.key === '2'">
                  <v-item-group mandatory v-model="selectedTabEmoji">
                    <v-container class="pl-0 pr-0">
                      <v-row class="justify-center align-center">
                        <v-col @click="selectTitleEmoji(category)" v-for="(emojiGroup, category) in emojiGroups" :key="category" cols="2" align="center"
                          justify="center" class="pa-0 pt-3">
                          <v-item v-slot="{ active, toggle }">
                            <v-card :color="active ? '#9e9e9e9c' : 'white'" class="d-flex align-center" dark height="40"
                              width="40" @click="toggle">
                              <div class="flex-grow-1 text-center">
                                {{emojiGroup['smile']}}
                                {{emojiGroup['bear']}}
                                {{emojiGroup['soccer']}}
                                {{emojiGroup['house_with_garden']}}
                                {{emojiGroup['symbols']}}
                              </div>
                            </v-card>
                          </v-item>
                        </v-col>
                      </v-row>

                      <div class="list-overflow" v-if="token_emoji !== ''">
                        <v-row  class="pa-0 pt-3 justify-start align-center">
                          <v-col cols="2" v-for="(item, index) in list_emoji_token" :key="index">
                            <span class="emojis" @click="appendEmoji(item)">{{ item }}</span>
                          </v-col>
                        </v-row>
                      </div>
                    </v-container>
                  </v-item-group>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
var _ = require("lodash");
const emojiGroups = require('../../../../public/assets/json/emoji')
export default {
  props: {
    stickerDialog: Boolean,
    stickerDetail: Object,
    tokenuser: String,
    msgSend: String,
    endPosCursor: Number,
    startPosCursor: Number,
  },
  data() {
    return {
      new_startPost: 0,
      new_endPos: 0,
      selectedTabEmoji: 0,
      emojiGroups,
      list_title: [
        { key: '1', text: this.$t('ChatSide.sticker') },
        { key: '2', text: this.$t('ChatSide.emoji') }
      ],
      tabs: 'tab-1',
      list_messages: [],
      progress_search: false,
      progress_loading: false,
      scrollable: {
        height: "calc(100vh - 185px) !important",
      },
      stylechat: {
        "--Chat-Background": "white",
        "--Chat-HeaderColor": "white",
        "--Chat-HeaderBackground": "#2463af",
        "--Chat-HeaderPictureBorderRadius": "6px",
        "--Chat-ChatboxBackgroundOwner": "#34567f",
        "--Chat-ChatboxColorOwner": "white",
        "--Chat-ChatboxBorderOwner": "none",
        "--Chat-ChatboxBorderRadiusOwner": "6px",
        "--Chat-ChatboxColorNotSupportOwner": "#929292",
        "--Chat-ChatboxBackgroundOther": "#efefef",
        "--Chat-ChatboxColorOther": "#615f5f",
        "--Chat-ChatboxBorderOther": "none",
        "--Chat-ChatboxBorderRadiusOther": "6px",
        "--Chat-ChatboxColorNotSupportOther": "#b1b1b1",
        "--Chat-TypingboxBackground": "#2463af",
        "--Chat-TypingboxColor": "white",
        "--Chat-QuickReplyButtonBorder": "#2463af",
        "--Chat-QuickReplyButtonBackground": "white",
        "--Chat-QuickReplyButtonColor": "#2463af",
        "--Chat-Icon-Active": "white",
        "--Chat-ColorCancel": "#f44336",
        "--Chat-MainFontSize-All": this.$store.getters.mainFontSize,
        "--Chat-SubFontSize-All": this.$store.getters.subFontSize,
      },
      pos1: 0,
      pos2: 0,
      pos3: 0,
      pos4: 0,
      elmnt: "",
      user_profile: {},
      offset: 0,
      statusSearch: true,
      isLoading: false, // A flag to indicate if data is currently being fetched
      hasMoreData: true,
      list_sticker: [],
      token_sticker: "",
      token_emoji: "",
      list_sticker_token: [],
      list_sticker_emoji: [],
      list_sticker_title: [],
      new_message: '',
      old_emoji: "",
    };
  },
  watch: {
    msgSend () {
      // console.log("watch msg sticker =>", this.msgSend);
    },
    async stickerDialog() {
      if (this.stickerDialog) {
        // console.log("watch msgSend =>", this.msgSend);
        this.new_startPost = this.startPosCursor
        this.new_endPos = this.endPosCursor
        // this.new_message = this.msgSend
        this.getListSticker();
      }
    },
    startPosCursor (val) {
      // console.log("watch", val);
      this.new_startPost = val
    },
    endPosCursor (val) {
      // console.log("watch end", val);
      this.new_endPost = val
    },
  },
  async created() {
    // console.log("created msgSend =>", this.msgSend);
    this.new_startPost = this.startPosCursor
    this.new_endPos = this.endPosCursor
    this.getListSticker();
  },
  methods: {
    emitSticker (item) {
      this.$emit('emitComponents', {
        name: 'append-sticker',
        value: {
          data: item,
        }
      })
    },
    appendEmoji (item) {
      this.old_emoji = item
      // console.log("appendEmoji =>", this.old_emoji);
      // this.new_message = item
      this.$emit('emitComponents', {
        name: 'append-emoji',
        value: {
          data: item,
          // data: this.new_message
        }
      })
    },
    selectTitleEmoji (token) {
      // console.log("selectTitleEmoji => ", token);
      // console.log("emoji =>", this.emojiGroups[token]);
      this.token_emoji = token
      this.list_emoji_token = this.emojiGroups[token]
      // console.log("this.list_emoji_token =>", this.list_emoji_token);
    },
    selectTitleSticker (token) {
      this.token_sticker = token
      var me = this
      this.list_sticker_token = _.filter(me.list_sticker, function(o) { return o.path_title === me.token_sticker })
      // console.log("list_sticker_token =>", this.list_sticker_token);
    },
    getListSticker() {
      this.progress_loading = true;
      this.axios.post(process.env.VUE_APP_API_message + '/sticker/gettitleallsticker', { tokenuser: this.tokenuser }).then((responsed) => {
        if (responsed.data.status === 'success') {
          this.progress_loading = false
          this.list_sticker = responsed.data['data']
          // console.log(this.list_sticker)
          this.list_sticker_title = _.map(this.list_sticker, function(o) { return o.path_title })
          this.token_sticker = this.list_sticker_title[0]
          var me = this
          this.list_sticker_token = _.filter(me.list_sticker, function(o) { return o.path_title === me.token_sticker })
          this.selectTitleEmoji('People')
        }
      })
    },
    dragElement(event) {
      event = event || window.event;
      event.preventDefault();
      this.elmnt = this.$refs.sticker;

      this.pos3 = event.clientX;
      this.pos4 = event.clientY;

      const elementDrag = (e) => {
        e = e || window.event;
        e.preventDefault();
        this.pos1 = this.pos3 - e.clientX;
        this.pos2 = this.pos4 - e.clientY;
        this.pos3 = e.clientX;
        this.pos4 = e.clientY;
        this.elmnt.style.top = this.elmnt.offsetTop - this.pos2 + "px";
        this.elmnt.style.left = this.elmnt.offsetLeft - this.pos1 + "px";
      };

      const closeDragElement = () => {
        document.onmouseup = null;
        document.onmousemove = null;
      };

      document.onmouseup = closeDragElement;
      document.onmousemove = elementDrag;
    },
    closeDialog() {
      this.list_messages = [];
      this.$emit("closeComponents", {
        name: "sticker",
      });
    },
  },
};
</script>

<style lang="css" scoped>
/* .emojis {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  font-size: 30px !important;
  cursor: pointer;
} */
.emojis:after {
  content: "";
  flex: auto;
}
.emojis:before {
  content: "";
  flex: auto;
}
.emojis {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 5px !important;
  cursor: pointer !important;
  border-radius: 5px !important;
  font-size: 30px !important;
  color: aliceblue !important;
}
.emojis:hover {
  background: #ececec;
  cursor: pointer;
  font-size: 30px !important;
  padding: 5px !important;
}
.img-sticker {
  width: 80px !important;
  height: 80px !important;
  cursor: pointer !important;
}
.img-sticker:hover {
  width: 90px !important;
  height: 90px !important;
  cursor: pointer !important;
}
.highlight {
  color: yellow;
  font-weight: bold;
}

.text-overflow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 35vw;
}

.text-overflow-group {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 35vw;
}

.titleBar {
  background-color: var(--Chat-HeaderBackground) !important;
  height: 47px !important;
  margin-top: 0px !important;
  transform: translateY(0px) !important;
  left: 0px !important;
  right: 0px !important;
  cursor: pointer !important;
  ;
}

.HeaderName {
  color: var(--Chat-HeaderColor) !important;
  margin-left: 10px;
  /* font-size: 22px; */
  font-weight: 600;
}

.img-position {
  object-fit: cover;
  object-position: 50% 0;
  border-style: solid;
  border-width: thin;
  border-color: #e8e8e8;
}

.markMsgSearch {
  background-color: white !important;
  color: var(--Chat-Background) !important;
}

.main-fontsize {
  font-size: var(--Chat-MainFontSize-All) !important;
}

.sub-fontsize {
  font-size: var(--Chat-SubFontSize-All) !important;
}

.list-overflow {
  height: 345px !important;
  overflow-y: auto;
  margin-top: 20px;
  width: 100% !important;
  padding: 10px;
  overflow-x: hidden !important;
}

.list-overflow::-webkit-scrollbar {
  width: 4px;
}

.list-overflow::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
}
</style>